import Vue from 'vue';
import VueRouter from 'vue-router';
import { Message } from 'element-ui';
import store from '@/store';
import userAuth from '@/views/Login/user-auth';

const OrgnizationManagement = () => import('@/views/OrgnizationManagement/OrgnizationManagementView.vue');
const RolePermissionConfig = () => import('@/views/RolePermissionConfig/RolePermissionConfigView.vue');
const HomeView = () => import('@/views/Home/HomeView.vue');
const LayoutView = () => import('@/views/Layout/LayoutView.vue');
const LoginView = () => import(/* webpackChunkName: "login" */'@/views/Login/LoginView.vue');
const LoginVerificationCodeView = () => import(/* webpackChunkName: "login" */'@/views/Login/LoginVerificationCodeView.vue');
const MxGraphManageView = () => import('@/views/MxGraphManage/MxGraphManageView.vue');
const MxGraphEditView = () => import('@/views/MxgraphEdit/MxGraphEditView.vue');
const MxGraphDisplayView = () => import('@/views/MxgraphDisplay/MxGraphDisplayView.vue');
const ChangePwdView = () => import('@/views/ChangePwd/ChangePwdView.vue');
const NavMenuConfView = () => import('@/views/NavigationMenuConf/NavMenuConfView.vue');
const NavMenuItemConfView = () => import('@/views/NavigationMenuConf/NavMenuItemConfView.vue');
const NotFoundPage = () => import('@/views/ErrorView/NotFoundPage.vue');
const WaterSysOpParamQureyView = () => import('@/views/DataAnalysis/WaterSysOpParamQurey/WaterSysOpParamQureyView.vue');
const WaterSysOpParamManageView = () => import('@/views/DataAnalysis/WaterSysOpParamManage/WaterSysOpParamManageView.vue');
const SensorParameterAdj = () => import('@/views/ArtificialIntelligence/SensorParameterAdj/SensorParameterAdjView.vue');
const AllSensorParameterAdj = () => import('@/views/ArtificialIntelligence/AllSensorParameterAdj/AllSensorParameterAdjView.vue');
const SensorCompensationAdj = () => import('@/views/ArtificialIntelligence/SensorCompensationAdj/SensorCompensationAdjView.vue');
const Chiller = () => import('@/views/ArtificialIntelligence/Chiller/ChillerView.vue');
const AlarmConfigManagement = () => import('@/views/ArtificialIntelligence/AlarmManagement/AlarmConfigManagement.vue');
const AlarmHistory = () => import('@/views/ArtificialIntelligence/AlarmManagement/AlarmHistory.vue');
const AlarmRealTime = () => import('@/views/ArtificialIntelligence/AlarmManagement/AlarmRealTime.vue');
const AllSysCoolingOverview = () => import('@/views/EnergyManage/AllSysCoolingOverview/AllSysCoolingOverview.vue');
const CoolingOverView = () => import('@/views/EnergyManage/CoolingOverView/CoolingOverView.vue');
const CoolingPriceManageView = () => import('@/views/EnergyManage/CoolingPriceManage/CoolingPriceManageView.vue');
const LineAndStation = () => import('@/views/LineAndStation/LineAndStationView.vue');
const VirtualPointManagementView = () => import('@/views/VirtualPointCodeManagement/VirtualPointCodeManagementView.vue');
const HomeViewBgConfView = () => import('@/views/HomeViewBgConf/HomeViewBgConfView.vue');
const HomeConf = () => import('@/views/HomeConfManagement/HomeConf.vue');
const ClockCheckView = () => import('@/views/ClockCheck/ClockCheckView.vue');
const CoolingPriceRateManageView = () => import('@/views/EnergyManage/CoolingPriceRateManage/CoolingPriceRateManageView.vue');
const SysConfigView = () => import('@/views/SysConfigView/SysConfigView.vue');
const DeviceManagement = () => import('@/views/PointRuleManagement/DeviceManagement/DeviceManagementView.vue');
const BatchPointManagement = () => import('@/views/PointRuleManagement/BatchPointManagement/BatchPointManagementView.vue');
const BatchPointExport = () => import('@/views/PointRuleManagement/BatchPointExport/BatchPointExportView.vue');
const LogoManageView = () => import('@/views/LogoManage/LogoManageView.vue');
const OperationParam = () => import('@/views/ArtificialIntelligence/OperationParamManagement/OperationParam.vue');
const GraphDisplay = () => import('@/views/ArtificialIntelligence/OperationParamManagement/GraphDisplay.vue');
const SysOpParamMonitor = () => import('@/views/DataAnalysis/SysOpParamMonitor/SysOpParamMonitor.vue');
const PointCodeLabelManagementView = () => import('@/views/PointCodeLabelManagement/PointCodeLabelManagement.vue');
const SoonSpace3dDisplayView = () => import('@/views/SoonSpace3dDisplay/SoonSpace3dDisplayView.vue');
const MixDisplayView = () => import('@/views/MixedDisplay/MixedDisplayView.vue');
const SoonSpace3dManageView = () => import('@/views/SoonSpace3dManage/SoonSpace3dManageView.vue');
const OpeningApplicationManagement = () => import('@/views/OpeningConfig/OpeningApplicationManagement/OpeningApplicationManagementView.vue');
const OpeningPointManagement = () => import('@/views/OpeningConfig/OpeningPointManagement/OpeningPointManagementView.vue');
const DeviceTypeManagementView = () => import('@/views/DeviceTypeManagement/DeviceTypeManagementView.vue');
const OpeningPointWarningManagement = () => import('@/views/OpeningConfig/OpeningPointWarningManagement/OpeningPointWarningManagementView.vue');
const ReportExportManagement = () => import('@/views/ReportExportManagement/ReportExportView.vue');
const PointDataTransmissionManagement = () => import('@/views/PointDataTransmissionManagement/PointDataTransmissionManagement.vue');
const DeviceControlTaskManagement = () => import('@/views/DeviceControlTaskManagement/DeviceControlTaskManagement.vue');
const IPManagement = () => import('@/views/IPManagement/IPManagement.vue');
const changeURL = () => import('@/views/ChangeURL/changeURL.vue');
const LoginLogManagement = () => import('@/views//LogManagement/LoginLogManagement/LoginLogManagement.vue')
const PlcCommandLogManagement = () => import('@/views/LogManagement/PlcCommandLogManagement/PlcCommandLogManagement.vue')
const CommandDispatchLogView = () => import('@/views/CommandDispatchLog/CommandDispatchLogView.vue')
const LowEnergyConsumptionPlatform = () => import('@/views/Platforms/LowEnergyConsumptionPlatform/LowEnergyConsumptionPlatform.vue')
const DispatchMonitoringSubsystem = () => import('@/views/Platforms/DispatchMonitoringSubsystem/DispatchMonitoringSubsystem.vue')
const ManagementCockpit = () => import('@/views/Platforms/ManagementCockpit/ManagementCockpit.vue')
const PerformanceManagementSystem = () => import('@/views/Platforms/PerformanceManagementSystem/PerformanceManagementSystem.vue')
const EnergyManagementSubsystem = () => import('@/views/Platforms/EnergyManagementSubsystem/EnergyManagementSubsystem.vue')
const EnergyConservationManagementSystem = () => import('@/views/Platforms/EnergyConservationManagementSystem/EnergyConservationManagementSystem.vue')
const CarbonEmissionMonitoringSystem = () => import('@/views/Platforms/CarbonEmissionMonitoringSystem/CarbonEmissionMonitoringSystem.vue')
const CarbonAssetManagementSystem = () => import('@/views/Platforms/CarbonAssetManagementSystem/CarbonAssetManagementSystem.vue')
const AlarmSMSSettings = () => import('@/views/AlarmSMSSettings/AlarmSMSSettings.vue')
const CumulativePoints = () => import('@/views/CumulativePoints/CumulativePoints.vue')
const OMRecord = () => import('@/views/ArtificialIntelligence/OMRecordManagement/OMRecord.vue')
const DataVDisplayView = () => import('@/views/DataVDisplay/DataVDisplayView.vue')
const BigScreenGZY = () => import('@/views/DataVDisplay/components/BigScreenGZY.vue')
const IntelligentOMGZY = () => import('@/views/DataVDisplay/components/IntelligentOMGZY.vue')


Vue.use(VueRouter);
const routes = [
  {
    path: '/management',
    name: 'layout',
    component: LayoutView,
    children: [
      {
        path: 'orgnizationManagement',
        name: 'orgnizationManagement',
        component: OrgnizationManagement,
      },
      {
        path: 'rolePermissionConfig',
        name: 'rolePermissionConfig',
        component: RolePermissionConfig,
      },
      {
        path: 'fileList',
        name: 'fileList',
        component: MxGraphManageView,
      },
      {
        path: 'editGraph',
        props: true,
        name: 'editGraph',
        component: MxGraphEditView,
      },
      {
        path: 'monitorGraph',
        props: (route) => ({ ...route.params, graphId: route.query.graphId || '' }),
        name: 'monitorGraph',
        component: MxGraphDisplayView,
      },
      {
        path: 'monitor3d',
        props: true,
        name: 'monitor3d',
        component: SoonSpace3dDisplayView,
      },
      {
        path: 'mixedDisplay',
        props: true,
        name: 'mixedDisplay',
        component: MixDisplayView,
      },
      {
        path: 'DataVDisplay',
        props: true,
        name: 'DataVDisplay',
        component: DataVDisplayView,
      },
      {
        path: 'ai',
        name: 'ai',
        component: {
          render: (e) => e('router-view'),
        },
        children: [
          {
            path: 'sensorAdj',
            name: 'sensorAdj',
            component: SensorParameterAdj,
          },
          {
            path: 'allSensorAdj',
            name: 'allSensorAdj',
            component: AllSensorParameterAdj,
          },
          {
            path: 'sensorCompensation',
            name: 'sensorCompensation',
            component: SensorCompensationAdj,
          },
          {
            path: 'chiller',
            name: 'chiller',
            component: Chiller,
          },
          {
            path: 'alarmConfigManagement',
            name: 'alarmConfigManagement',
            component: AlarmConfigManagement,
          },
          {
            path: 'alarmHistory',
            name: 'alarmHistory',
            component: AlarmHistory,
          },
          {
            path: 'alarmRealTime',
            name: 'alarmRealTime',
            component: AlarmRealTime,
          },
          {
            path: 'operationParam',
            name: 'operationParam',
            component: OperationParam,
          },
          {
            path: 'GraphDisplay',
            name: 'GraphDisplay',
            component: GraphDisplay,
          },
          {
            path: 'OMRecord',
            name: 'OMRecord',
            component: OMRecord,
          },
        ],
      },
      {
        path: 'navigationMenuConf',
        name: 'navigationMenuConf',
        component: NavMenuConfView,
      },
      {
        path: 'navigationMenuItemConf',
        name: 'navigationMenuItemConf',
        component: NavMenuItemConfView,
      },
      {
        path: 'WaterSysOpParamQurey',
        name: 'WaterSysOpParamQurey',
        component: WaterSysOpParamQureyView,
      },
      {
        path: 'WaterSysOpParamManageView',
        name: 'WaterSysOpParamManageView',
        component: WaterSysOpParamManageView,
      },
      {
        path: 'AllSysCoolingOverview',
        name: 'AllSysCoolingOverview',
        component: AllSysCoolingOverview,
      },
      {
        path: 'CoolingOverView',
        name: 'CoolingOverView',
        component: CoolingOverView,
      },
      {
        path: 'CoolingPriceManageView',
        name: 'CoolingPriceManageView',
        component: CoolingPriceManageView,
      },
      {
        path: 'LineAndStation',
        name: 'LineAndStation',
        component: LineAndStation,
      },
      {
        path: 'VirtualPointManagementView',
        name: 'VirtualPointManagementView',
        component: VirtualPointManagementView,
      },
      {
        path: 'PointCodeLabelManagementView',
        name: 'PointCodeLabelManagementView',
        component: PointCodeLabelManagementView,
      },
      {
        path: 'HomeViewBgConfView',
        name: 'HomeViewBgConfView',
        component: HomeViewBgConfView,
      },
      {
        path: 'HomeConf',
        name: 'HomeConf',
        component: HomeConf,
      },
      {
        path: 'ClockCheckView',
        name: 'ClockCheckView',
        component: ClockCheckView,
      },
      {
        path: 'SysConfigView',
        name: 'SysConfigView',
        component: SysConfigView,
      },
      {
        path: 'CoolingPriceRateManageView',
        name: 'CoolingPriceRateManageView',
        component: CoolingPriceRateManageView,
      },
      {
        path: 'DeviceManagement',
        name: 'DeviceManagement',
        component: DeviceManagement,
      },
      {
        path: 'BatchPointManagement',
        name: 'BatchPointManagement',
        component: BatchPointManagement,
      },
      {
        path: 'BatchPointExport',
        name: 'BatchPointExport',
        component: BatchPointExport,
      },
      {
        path: 'LogoManageView',
        name: 'LogoManageView',
        component: LogoManageView,
      },
      {
        path: 'SysOpParamMonitor',
        name: 'SysOpParamMonitor',
        component: SysOpParamMonitor,
      },
      {
        path: 'ModelManageView',
        name: 'ModelManageView',
        component: SoonSpace3dManageView,
      },
      {
        path: 'OpeningApplicationManagement',
        name: 'OpeningApplicationManagement',
        component: OpeningApplicationManagement,
      },
      {
        path: 'OpeningPointManagement',
        name: 'OpeningPointManagement',
        component: OpeningPointManagement,
      },
      {
        path: 'DeviceTypeManagementView',
        name: 'DeviceTypeManagementView',
        component: DeviceTypeManagementView,
      },
      {
        path: 'OpeningPointWarningManagement',
        name: 'OpeningPointWarningManagement',
        component: OpeningPointWarningManagement,
      },
      {
        path: 'ReportExportManagement',
        name: 'ReportExportManagement',
        component: ReportExportManagement,
      },
      {
        path: 'PointDataTransmissionManagement',
        name: 'PointDataTransmissionManagement',
        component: PointDataTransmissionManagement,
      },
      {
        path: 'DeviceControlTaskManagement',
        name: 'DeviceControlTaskManagement',
        component: DeviceControlTaskManagement,
      },
      {
        path: 'IPManagement',
        name: 'IPManagement',
        component: IPManagement,
      },
      {
        path: 'LowEnergyConsumptionPlatform',
        name: 'LowEnergyConsumptionPlatform',
        component: LowEnergyConsumptionPlatform,
      },
      {
        path: 'DispatchMonitoringSubsystem',
        name: 'DispatchMonitoringSubsystem',
        component: DispatchMonitoringSubsystem,
      },
      {
        path: 'ManagementCockpit',
        name: 'ManagementCockpit',
        component: ManagementCockpit,
      },
      {
        path: 'PerformanceManagementSystem',
        name: 'PerformanceManagementSystem',
        component: PerformanceManagementSystem,
      },
      {
        path: 'EnergyManagementSubsystem',
        name: 'EnergyManagementSubsystem',
        component: EnergyManagementSubsystem,
      },
      {
        path: 'EnergyConservationManagementSystem',
        name: 'EnergyConservationManagementSystem',
        component: EnergyConservationManagementSystem,
      },
      {
        path: 'CarbonEmissionMonitoringSystem',
        name: 'CarbonEmissionMonitoringSystem',
        component: CarbonEmissionMonitoringSystem,
      },
      {
        path: 'CarbonAssetManagementSystem',
        name: 'CarbonAssetManagementSystem',
        component: CarbonAssetManagementSystem,
      },
      {
        path: 'AlarmSMSSettings',
        name: 'AlarmSMSSettings',
        component: AlarmSMSSettings,
      },
      {
        path: 'CumulativePoints',
        name: 'CumulativePoints',
        component: CumulativePoints,
      },
      {
        path: 'LogManagement',
        name: 'LogManagement',
        component: {
          render: (h) => h('router-view'),
        },
        children: [
          {
            path: 'PlcCommandLogManagement',
            name: 'PlcCommandLogManagement',
            component: PlcCommandLogManagement,
          },
          {
            path: 'LoginLogManagement',
            name: 'LoginLogManagement',
            component: LoginLogManagement,
          },
          {
            path: 'CommandDispatchLog',
            name: 'CommandDispatchLogSub',
            component: CommandDispatchLogView,
          },
        ],
      },
      {
        path: 'commandDispatchLog',
        name: 'commandDispatchLog',
        component: CommandDispatchLogView,
      },
      {
        path: 'CommandDispatchLog',
        name: 'CommandDispatchLog',
        component: CommandDispatchLogView,
      },
      {
        path: 'system-config/commandDispatchLog',
        name: 'systemConfigCommandDispatchLog',
        component: CommandDispatchLogView,
      },
      {
        path: 'DataVDisplayView',
        name: 'DataVDisplayView',
        component: DataVDisplayView,
      },
      {
        path: 'IntelligentOMGZY',
        name: 'IntelligentOMGZY',
        component: IntelligentOMGZY,
      },
      {
        path: 'BigScreenGZY',
        name: 'BigScreenGZY',
        component: BigScreenGZY,
      },
    ],
  },
  {
    path: '/',
    name: 'home',
    beforeEnter(to, from, next) {
      window.location.href = '/dashboard/map_overview.html';
    },
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: ChangePwdView,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/loginVerificationCode',
    name: 'loginVerificationCode',
    component: LoginVerificationCodeView,
  },
  {
    name: '404',
    path: '/404',
    component: NotFoundPage,
  },
  {
    name: 'changeURL',
    path: '/changeURL',
    component: changeURL,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const KEHUI_METRO_ORGS = [2, 3, 12, 36, 37, 38, 44, 45, 46];
const ALLOWED_ROLES = ['sys_admin', 'admin', 'manager', 'operator'];

function hasManagementAccess() {
  try {
    const rawProfile = localStorage.getItem('userProfile');
    const userProfile = rawProfile ? JSON.parse(rawProfile) : (store.state.user && store.state.user.userProfile ? store.state.user.userProfile : {});
    
    // 1. 管理员及公司用户默认具备权限
    const role = userProfile.role || userProfile.roleCode || localStorage.getItem('userRole') || '';
    if (ALLOWED_ROLES.includes(role)) {
      return true;
    }

    // 2. 广州科慧能源有限公司及其下属运维部/班组，以及广州地铁设计研究院账号默认具备权限
    const userOrgInfo = userProfile.userOrgInfo || {};
    const companyId = Number(userOrgInfo.companyId || userProfile.companyId);
    const departmentId = Number(userOrgInfo.departmentId || userProfile.departmentId);
    const orgId = Number(userProfile.orgId || userProfile.org_id || departmentId || companyId);
    
    const companyName = userOrgInfo.companyName || userProfile.companyName || '';
    const departmentName = userOrgInfo.departmentName || userProfile.departmentName || '';
    const orgName = userProfile.orgName || userOrgInfo.orgName || '';
    const fullOrgText = `${companyName} ${departmentName} ${orgName}`;

    // 校验组织 ID
    if (
      KEHUI_METRO_ORGS.includes(companyId) ||
      KEHUI_METRO_ORGS.includes(departmentId) ||
      KEHUI_METRO_ORGS.includes(orgId)
    ) {
      return true;
    }

    // 校验组织名称
    if (
      fullOrgText.includes('科慧') ||
      fullOrgText.includes('地铁设计') ||
      fullOrgText.includes('广州科慧') ||
      fullOrgText.includes('广州地铁')
    ) {
      return true;
    }

    // 3. 显式授予 page:management 权限
    const perms = userProfile.permissions || [];
    if (perms.some(p => p === 'page:management' || p.startsWith('page:management:'))) {
      return true;
    }

    return false;
  } catch (e) {
    console.error('Permission check error:', e);
    return false;
  }
}

router.beforeEach((to, from, next) => {
  console.debug(store.getters.isAuthenticated);
  if (!store.getters.isAuthenticated && to.name !== 'login') {
    userAuth.stopDetectUserIsAlive();
    next({ name: 'login' });
  } else if (to.matched.length === 0) {
    userAuth.startDetectUserIsAlive();
    next({ name: '404' });
  } else {
    if (!store.getters.isAuthenticated && to.name === 'login') {
      userAuth.stopDetectUserIsAlive();
    } else {
      userAuth.startDetectUserIsAlive();
    }

    // 针对 /management 路由进行严格的权限拦截校验
    if (to.path.startsWith('/management')) {
      if (!hasManagementAccess()) {
        Message({
          message: '抱歉，您暂无访问组态监控平台(/management)的权限！',
          type: 'warning',
          duration: 4000
        });
        setTimeout(() => {
          window.location.href = '/dashboard/energy';
        }, 300);
        return;
      }
    }

    next();
  }
});

export default router;
